var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "menu",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2,
    x: 3,
    y: 11,
    rx: 0.95,
    ry: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2,
    x: 3,
    y: 16,
    rx: 0.95,
    ry: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2,
    x: 3,
    y: 6,
    rx: 0.95,
    ry: 0.95
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.316acf9a50d406606198605d58e306f1.svg";
export { ForwardRef as ReactComponent };